// extracted by mini-css-extract-plugin
export default {"haveQuestions":"cfuVB","haveQuestionsText":"QQoiZ"};